import {
  isSupportedLanguageObject,
  LanguageObject,
  codeToLanguageCodes,
} from "@flat-ui";
import { useLocalize } from "@faro-lotv/foreign-observers";

interface ReturnProps {
  /** All the supported languages */
  supportedLanguages: LanguageObject[];

  /** The current selected language */
  currentLanguage: LanguageObject;
}

/** A hook that handles all the utility functions for language selector */
export function useLanguage(): ReturnProps {
  const { availableLanguages, currentLanguage: LocalizeCurrentLanguage } =
    useLocalize();

  return {
    supportedLanguages: availableLanguages.filter(isSupportedLanguageObject),
    currentLanguage: {
      code: codeToLanguageCodes(LocalizeCurrentLanguage.code),
      name: LocalizeCurrentLanguage.name,
    },
  };
}
